import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12m6.223-7.785c.148 0 .268-.12.268-.268V8.414l-6.105 4.848a.62.62 0 0 1-.772 0L5.509 8.414v7.533c0 .148.12.268.268.268zm-.936-8.43L12 11.982 6.713 7.784zm2.446.268v7.894c0 .833-.678 1.51-1.51 1.51H5.777c-.833 0-1.51-.677-1.51-1.51V8.053c0-.833.677-1.51 1.51-1.51h12.446c.832 0 1.51.677 1.51 1.51",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }